export var PreferredNameEnum;
(function (PreferredNameEnum) {
    PreferredNameEnum[PreferredNameEnum["Full Name"] = 1] = "Full Name";
    PreferredNameEnum[PreferredNameEnum["First Name"] = 2] = "First Name";
    PreferredNameEnum[PreferredNameEnum["Last Name"] = 3] = "Last Name";
})(PreferredNameEnum || (PreferredNameEnum = {}));
export var GenderEnum;
(function (GenderEnum) {
    GenderEnum[GenderEnum["Unselected"] = 0] = "Unselected";
    GenderEnum[GenderEnum["Male"] = 1] = "Male";
    GenderEnum[GenderEnum["Female"] = 2] = "Female";
    GenderEnum[GenderEnum["Prefer Not to Say"] = 3] = "Prefer Not to Say";
    GenderEnum[GenderEnum["Other"] = 9] = "Other";
})(GenderEnum || (GenderEnum = {}));
export var PurposeEnum;
(function (PurposeEnum) {
    PurposeEnum[PurposeEnum["To improve Japanese language ability"] = 1] = "To improve Japanese language ability";
    PurposeEnum[PurposeEnum["To immigrate to Japan"] = 2] = "To immigrate to Japan";
    PurposeEnum[PurposeEnum["To work in Japan"] = 3] = "To work in Japan";
    PurposeEnum[PurposeEnum["To comprehend Japanese culture"] = 4] = "To comprehend Japanese culture";
})(PurposeEnum || (PurposeEnum = {}));
export var EmploymentHopeEnum;
(function (EmploymentHopeEnum) {
    EmploymentHopeEnum[EmploymentHopeEnum["Unselected"] = 0] = "Unselected";
    EmploymentHopeEnum[EmploymentHopeEnum["InJapan"] = 1] = "InJapan";
    EmploymentHopeEnum[EmploymentHopeEnum["JapaneseCompany"] = 2] = "JapaneseCompany";
    EmploymentHopeEnum[EmploymentHopeEnum["Neither"] = 3] = "Neither";
})(EmploymentHopeEnum || (EmploymentHopeEnum = {}));
export const JapaneseConversationLevelArr = [
    {
        show: false,
        text: 'Not set',
        value: 0,
        intlid: 'evaluation.category.placeholder',
    },
    {
        show: true,
        text: 'Little to no understanding',
        value: 1,
        intlid: 'edit.conversation_level_1',
    },
    {
        show: true,
        text: 'Knowledge of basic vobaulary',
        value: 2,
        intlid: 'edit.conversation_level_2',
    },
    {
        show: true,
        text: 'Able to form simple sentences',
        value: 3,
        intlid: 'edit.conversation_level_3',
    },
    {
        show: true,
        text: 'Daily conversation level',
        value: 4,
        intlid: 'edit.conversation_level_4',
    },
    {
        show: true,
        text: 'Able to handle complex topics',
        value: 5,
        intlid: 'edit.conversation_level_5',
    },
];
export const JLPTLevelArr = [
    {
        text: 'I have never taken the JLPT',
        value: -10,
        intlid: 'edit.not_taken_jlpt',
    },
    {
        text: 'I have never passed the JLPT',
        value: -1,
        intlid: 'edit.not_passed_jlpt',
    },
    {
        text: 'N5',
        value: 5,
        intlid: 'edit.jlpt_5',
    },
    {
        text: 'N4',
        value: 4,
        intlid: 'edit.jlpt_4',
    },
    {
        text: 'N3',
        value: 3,
        intlid: 'edit.jlpt_3',
    },
    {
        text: 'N2',
        value: 2,
        intlid: 'edit.jlpt_2',
    },
    {
        text: 'N1',
        value: 1,
        intlid: 'edit.jlpt_1',
    },
];
const levelToText = (levelArr, value) => {
    const specifiedLevel = levelArr.find((level) => level.value === value);
    return specifiedLevel ? specifiedLevel.text : '';
};
export const JLPTLevelToText = (value) => levelToText(JLPTLevelArr, value);
export const JapaneseConversationLevelToText = (value) => levelToText(JapaneseConversationLevelArr, value);
export var NamePreferences;
(function (NamePreferences) {
    NamePreferences[NamePreferences["FullName"] = 1] = "FullName";
    NamePreferences[NamePreferences["FirstName"] = 2] = "FirstName";
    NamePreferences[NamePreferences["LastName"] = 3] = "LastName";
})(NamePreferences || (NamePreferences = {}));
export const NamePreferenceLabels = {
    [NamePreferences.FullName]: {
        intlid: 'edit.name_preference.full_name',
    },
    [NamePreferences.FirstName]: {
        intlid: 'edit.name_preference.first_name',
    },
    [NamePreferences.LastName]: {
        intlid: 'edit.name_preference.last_name',
    },
};
export const GenderPreferenceLabels = [
    {
        intlid: 'edit.gender.male',
        value: 1,
    },
    {
        intlid: 'edit.gender.female',
        value: 2,
    },
    {
        intlid: 'edit.gender.other',
        value: 9,
    },
    {
        intlid: 'edit.gender.prefer_not_to_say',
        value: 3,
    },
];
export const EmploymentHopeOption = [
    {
        intlid: 'edit.employment.hope.option.first',
        value: 1,
    },
    {
        intlid: 'edit.employment.hope.option.second',
        value: 2,
    },
    {
        intlid: 'edit.employment.hope.option.third',
        value: 3,
    },
];
